module.exports = {
	torocco_productId: 'bb6cdfa8-3365-4fbc-9f50-72fb91ca23ba',
	torocco_planId: '13911010-6a99-4adf-a41c-d26c79ee4c4d',
	torocco_planId_additional: ['d2b1251f-439e-45dd-8fa7-20d0b0958160'],
	kiha40_productId: '31cc9d68-0cd8-4130-9dc7-71579a45bdff',
	kiha40_planId: 'dc9efb3a-8a4b-4e93-9d4a-74e172448fcd',
	service: 'jorudan',
	hostName: 'https://rsvapi.jorudan.co.jp',
	loginRedirectUrl: 'https://jid.jorudan.co.jp/account/fa/login.html?srvid=ticket&returl=https://ticket.jorudan.co.jp/reserve/kominato/home',
	logoutRedirectUrl: 'https://jid.jorudan.co.jp/account/fa/logout.html?srvid=ticket&returl=https://www.kominato.co.jp/satoyamatorocco/',
	userPageUrl: 'https://jid.jorudan.co.jp/account/',
	isProduct: true,
	web_url: 'https://ticket.jorudan.co.jp/'
}